interface TableSkeletonProps {
  rows?: number;
  columns?: number;
}

/** Placeholder de carga con la forma de la tabla de tenants. */
export function TableSkeleton({ rows = 6, columns = 5 }: TableSkeletonProps) {
  return (
    <div className="table-wrap" aria-hidden="true">
      <table className="tbl">
        <tbody>
          {Array.from({ length: rows }).map((_, r) => (
            <tr key={r}>
              {Array.from({ length: columns }).map((__, c) => (
                <td key={c}>
                  <div
                    className="skeleton-row"
                    style={{ width: c === 0 ? '70%' : '45%' }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
